export default {
  form: {
    sending: 'Sending request…',
    success: 'Thanks! Our team will get in touch shortly',
    error: 'Sorry! Something went wrong. Try again or contact us at'
  }
}
